import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5151395e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151395e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5151395e')) {
      api.createRecord('5151395e', component.options)
    } else {
      api.reload('5151395e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5151395e&scoped=true&", function () {
      api.rerender('5151395e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/pv/index.vue"
export default component.exports